module.exports = __webpack_public_path__ + "static/img/family-introduction.6834146.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/family-introduction.jpg
// module id = xcFI
// module chunks = 21